// extracted by mini-css-extract-plugin
export var teaserVideo = "fluidVideo-module--teaserVideo--F8rvG";
export var videoModal = "fluidVideo-module--videoModal--46bsk";
export var wrapper = "fluidVideo-module--wrapper--1l31G";